import React from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import Navbar from './Navbar';
import About from './About';
import Projects from './Projects';
import Contact from './Contact';  // Importeer de Contact component
import Home from './Home'; // Importeer de Home component
import './App.css';  // Zorg ervoor dat de juiste css hier wordt geladen
import { LanguageProvider } from './Contexts/LanguageContext'; // Importeer de LanguageProvider

function App() {
  return (
    <LanguageProvider>
      <Router>
        <div className="App">
          {/* De navbar is altijd zichtbaar */}
          <Navbar />
          {/* Routes voor de pagina's */}
          <Routes>
            <Route path="/" element={<Home />} /> {/* Home pagina */}
            <Route path="/about" element={<About />} /> {/* About pagina */}
            <Route path="/projects" element={<Projects />} /> {/* Projecten pagina */}
            <Route path="/contact" element={<Contact />} /> {/* Contact pagina */}
          </Routes>
        </div>
      </Router>
    </LanguageProvider>
  );
}

export default App;
